module.exports = __webpack_public_path__ + "static/media/w0.c4484400.svg";